import type React from 'react';

export const EMPTY_OBJECT = Object.freeze({});
export const EMPTY_ARRAY = Object.freeze([]) as unknown as unknown[];

export function NULL_COMPONENT(): React.ReactNode {
  return null;
}
